// extracted by mini-css-extract-plugin
export default {"wrapper":"rQ-z"};